
























































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { Client, UserRole, UserRoles } from "bancojs";
import { getRoleString } from "@/views/admin/users/Index.vue";

@Component
export default class AdminClientsEdit extends Vue {
  async created() {
    if (this.$route.params.id) {
      try {
        const res = await $api.client.admin.clients
          .get(this.$route.params.id)
          .toPromise();
        this.form.data = Object.assign(this.form.data, res);
      } catch (err) {
        console.log(err);
      } finally {
        this.form.loading = false;
      }
    } else {
      this.form.editing = false;
      this.form.loading = false;
    }
  }

  async saveClient() {
    this.form.saving = true;
    try {
      if (this.form.editing) {
        const user = await $api.client.admin.clients
          .update(this.form.data.id, this.form.data)
          .toPromise();
      } else {
        const user = await $api.client.admin.clients
          .create(this.form.data)
          .toPromise();
      }
      this.form.saving = false;
      this.$router.push("/admin/clients");
    } catch (err) {
      console.log(err);
      this.form.saving = false;
    }
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    email: (val: any) => /.+@.+/.test(val) || 'Email inválido.',
  };

  get roles() {
    return UserRoles.map((role) => {
      return { text: getRoleString(role as UserRole), value: role };
    });
  }

  roleDisabled(role: { text: string; value: UserRole }) {
    return role.value != "ADMIN" &&
      this.form.data &&
      this.form.data.roles.includes("ADMIN")
      ? true
      : false;
  }

  @Watch("form.data.roles")
  onAdminRoleSelect(newValue: UserRole[]) {
    if (newValue.length > 1 && newValue.includes("ADMIN")) {
      this.form.data.roles = ["ADMIN"];
    }
  }

  form: {
    data: Client;
    saving: boolean;
    loading: boolean;
    editing: boolean;
    validForm: boolean;
  } = {
    data: {
      id: "",
      email: "",
      state: "ACTIVE",
      name: "",
      roles: [],
    },
    saving: false,
    loading: true,
    editing: true,
    validForm: false,
  };
}
